import type { WritableBitmap } from "./types.ts";

/**
 * Performs bitwise NOT operation on a WritableBitmap in-place.
 * This inverts all pixel values (255 - value for each channel).
 * @param bitmap - The bitmap to perform the operation on
 */
function bitwiseNot(bitmap: WritableBitmap): void {
	const { data } = bitmap;
	const length = data.length;

	for (let i = 0; i < length; i++) {
		data[i] = 255 - data[i];
	}
}

export default bitwiseNot;
